import { render, staticRenderFns } from "./OptionsTemp.vue?vue&type=template&id=0864c097&scoped=true&"
import script from "./OptionsTemp.vue?vue&type=script&lang=ts&"
export * from "./OptionsTemp.vue?vue&type=script&lang=ts&"
import style0 from "./OptionsTemp.vue?vue&type=style&index=0&id=0864c097&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0864c097",
  null
  
)

export default component.exports